import { NORECORDS } from "../../Services/CommonLibrary"
import LoadingComponent from "../components/LoadingComponent"

export default (({ onClose, title = "Referral Report", loading = false }) => {
    return <>
        <div className="modal-header">
            <div className="d-flex justify-content-between w-full align-items-center">
                <h5 className="modal-title">
                    {title}
                </h5>
            </div>
            <button type="button" className="btn-close" onClick={() => onClose(false)}></button>
        </div>
        <div className="modal-body p-6">
            {
                loading ?
                    <LoadingComponent />
                    : <div className="py-10"><NORECORDS message={`Record Not Found!`} marginTop="1px" /></div>
            }
        </div>
    </>
})